import { YieldType } from "../../../service/globalTypes";
import { setErrorInSpecificYield } from "../../../service/producerServices";
import { ManageErrorReSendingValuesArgs } from "./types";

export const manageErrorReSendingValues = ({
  currentErrorSentYields,
  errorData,
  row,
  statusCodes,
  errorsThatCantBeSent,
}: ManageErrorReSendingValuesArgs) => {
  const sentRow = row - 1;

  const errorAlreadyExists = errorsThatCantBeSent.find(
    (error) => error.security.securityProducerId === errorData.securityProducerId
  );

  const deletedErrorToReSend = errorAlreadyExists || { security: errorData, statusCodes: {} };

  if (!currentErrorSentYields.length) {
    [YieldType.BID, YieldType.ASK].forEach((yieldType) => {
      if (!errorData[yieldType]) return;

      deletedErrorToReSend.statusCodes[yieldType] = statusCodes[yieldType];

      if (errorAlreadyExists) deletedErrorToReSend.security[yieldType] = errorData[yieldType];

      setErrorInSpecificYield({ yieldType, sentRow });
    });
  } else {
    currentErrorSentYields.forEach((yieldType) => {
      const yieldTypeError = yieldType === YieldType.BID ? YieldType.ASK : YieldType.BID;

      deletedErrorToReSend.statusCodes[yieldTypeError] = statusCodes[yieldTypeError];

      delete deletedErrorToReSend.security[yieldType];

      setErrorInSpecificYield({ yieldType: yieldTypeError, sentRow });
    });
  }

  !errorAlreadyExists && errorsThatCantBeSent.unshift(deletedErrorToReSend);
};
